import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBydvc724djmUHFsbQ2P-AkF5jFXrjDfrY",
    authDomain: "facebook-clone-2c8f3.firebaseapp.com",
    projectId: "facebook-clone-2c8f3",
    storageBucket: "facebook-clone-2c8f3.appspot.com",
    messagingSenderId: "183767096081",
    appId: "1:183767096081:web:b3b2b36c50abab3d360ab0",
    measurementId: "G-68X895RPJL"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
// call google login service
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;